import { auth } from '@monorepo/utils/firebase'
import { log } from '@monorepo/utils/utils'
import { signInAnonymously as signInAnonymouslyFirebase } from '@monorepo/utils/firebase'
import { storeAnonymousUserId } from '../storeAnonymousUser'

export const signInAnonymously = async () => {
  if (auth().currentUser) return
  log('signInAnonymously')
  const { user } = await signInAnonymouslyFirebase(auth())
  log('signInAnonymously - user', user)

  // Store the anonymous user ID for potential future migration
  storeAnonymousUserId()

  return {
    provider: 'anonymous',
    user,
  }
}
